const AUTH_ERROR_MESSAGES: Record<string, string> = {
  "auth/user-not-found": "Invalid email or password.",
  "auth/invalid-credential": "Invalid email or password.",
  "auth/wrong-password": "Invalid email or password.",
  "auth/too-many-requests": "Too many attempts. Please try again later.",
  "auth/email-already-in-use": "An account with this email already exists.",
  "auth/weak-password": "Password is too weak. Please choose a stronger one.",
  "auth/network-request-failed": "Network error. Please check your connection.",
};

export const getAuthErrorMessage = (code: string): string =>
  AUTH_ERROR_MESSAGES[code] ?? "Something went wrong. Please try again.";
